<template>


<div id="cw" :class="['component-wrapper',
                     { 'is-hidden': indexHidden }]">

    <div class="index-portrait"></div>

    <!-- <section :class="['index', { 'mobile-padding': !portfolioLoaded }]"> -->
    <section class="index">

        <div class="branding">
            <div class="index-logo">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116 94"><path d="M12,0,0,4.1,4,16l12.25-3.833Z" fill="#2d2d2d"/><path d="M4,16l5,4,11.141-3.5L15.95,11.938Z" fill="#212121"/><path d="M20,16.5,16.9,6l-5-6,4,12Z" fill="#141414"/><path d="M32,7,20,8,35.133,23.617,46,19.8Z" fill="#4b4b4b"/><path d="M46,19.8l-8,13-11,5,7.9-14.77Z" fill="#343434"/><path d="M13,24,20,8,35,23,27,37.8Z" fill="#656565"/><path d="M50,19,30,34l14,6L66,23Z" fill="#bbb"/><path d="M56,61,44,40,30,34,41,53Z" fill="#cacaca"/><path d="M56,61,73,46,66,23,44,40Z" fill="#9a9a9a"/><path d="M86,32l6,37L56,84l1-32Z" fill="#f4f4f4"/><path d="M92,69l24,15L82,94,56,84Z" fill="#dbdad9"/><path d="M92,69,86,32l21,20,9,32Z" fill="#c1c1c1"/></svg>

                <h1>Pascal Klau<br>
                <small>Web Design</small></h1>

            </div>

            <!-- span for blendings -->
            <ul class="nav-social">
                <li>
                    <a @click="emitJump()">
                        <svg><use xlink:href="#icon-about"></use></svg>
                        <span>About</span>
                    </a>
                </li>

                <li>
                    <a href="https://github.com/pascalaoms" target="_blank" rel="noopener">
                        <svg><use xlink:href="#icon-gh"></use></svg>
                        <span>GitHub</span>
                    </a>
                </li>

                <li>
                    <a href="https://facebook.com/pascal.aoms" target="_blank" rel="noopener">
                        <svg><use xlink:href="#icon-fb"></use></svg>
                        <span>Facebook</span>
                    </a>
                </li>

                <li>
                    <a href="mailto:email@artofmyself.com">
                        <svg><use xlink:href="#icon-mail"></use></svg>
                        <span>E-Mail</span>
                    </a>
                </li>
            </ul>

        </div>

    </section>

    <section id="portfolio-web">

        <portfolio-web/>

    </section>

    <about-me/>

    <portfolio-graphics/>

</div>


</template>

<script>
import { Store, EventBus } from '@/main'

import PortfolioWeb      from './PortfolioWeb.vue'
import AboutMe           from './about-me.vue'
import PortfolioGraphics from './PortfolioGraphics.vue'

const jump = require('jump.js').default

export default {

    components: { PortfolioWeb, AboutMe, PortfolioGraphics },

    data() {
        return {
            indexHidden: true
        }
    },

    created() {

        window.scrollTo(0, Store.indexScrollTop)

        setTimeout(() => this.indexHidden = false, 50) // for smooth animation

    },

    mounted() {

        if( window.pageYOffset > 50 || Store.sliderLoadedOnce ) {
            EventBus.$emit('loadGraphics')
        }

    },

    beforeRouteLeave(to, from, next) {

        Store.indexScrollTop = window.pageYOffset

        this.indexHidden = true

        setTimeout(() => { // await transition out of index
            EventBus.$emit('isLoading', true)
            next()
        }, 400);
    },

    methods: {
        emitJump() {
            EventBus.$emit('jumpTo', '.interlude')
        }
    }

}


</script>



// WEBPACK FOOTER //
// Index.vue?32b9e52e